import * as React from 'react';
import { createStyles, Dialog, FormControl, InputLabel, makeStyles, Theme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import useCommonApi from '../../api/useCommonApi';
import ReactLoading from 'react-loading';
import { useState } from "react";
import ConfirmDialog from "./ConfirmDialog";
import { traducirMessage, traducirLabel, traducirButton } from '../../blocks/traductor';

interface Props {
    tipo: string
    abierto: boolean
    registroId: number
    confirmar: (terminarSolicitud?: boolean) => void
    abrirConfirmar?: boolean
    cerrar: () => void
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            display: 'block',
            flexDirection: 'column',
            margin: 'auto',
        },
        formControl: {
            display: 'block',
            marginTop: theme.spacing(2),
            minWidth: 120,
        },
        formControlLabel: {
            marginTop: theme.spacing(1),
        },
        error:
        {
            color: "red"
        },
        input:
        {
            width: "100%",
            height: "45px",
            padding: "0 1rem",
            marginTop: "1rem",
            boxSizing: "border-box",
            font: "inherit",
            borderRadius: "0.2rem",
            border: "2px solid #d4d5d6",
            color: "#565656",
        },
        inputError:
        {

            width: "100%",
            height: "45px",
            padding: "0 1rem",
            marginTop: "1rem",
            boxSizing: "border-box",
            font: "inherit",
            borderRadius: "0.2rem",
            border: "2px solid #d4d5d6",
            color: "#565656",
            borderColor: "red"
        },
        wrapper: {
            backgroundColor: "white",
            width: "400px",
            padding: "2rem",
            boxShadow: "0 1.5rem 1rem -1rem rgb(0 0 0 / 10%)",
            borderRadius: "0.3rem"
        },
        tagitem: {
            backgroundColor: "#d4d5d6",
            fontSize: "14px",
            borderRadius: "30px",
            height: "30px",
            padding: "0 4px 0 1rem",
            display: "inline-flex",
            alignItems: "center",
            margin: "0 0.3rem 0.3rem 0",
        },
        close: {
            backgroundColor: "white",
            width: "22px",
            height: "22px",
            borderRadius: "50%",
            border: "none",
            cursor: "pointer",
            font: "inherit",
            marginLeft: "10px",
            fontWeight: "bold",
            padding: "0",
            lineHeight: "1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }

    }),
);

const EnviarCorreoDialog = ({ tipo, abierto, cerrar, confirmar, registroId, abrirConfirmar = false }: Props) => {
    const apiSource = useCommonApi();
    const classes = useStyles();
    const [items, setItems] = React.useState<any[]>([]);
    const [value, setValue] = React.useState('');
    const [error, setError] = React.useState('');
    const [enviando, setEnviando] = React.useState(false);
    const [opcionesEnvio, setOpcionesEnvio] = useState({ dialogOpen: false, terminado: false });

    const handleKeyDown = (evt) => {
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();

            var value = evt?.target.value.trim();
            value = value.replace(" ", "");

            if (value && isValid(value)) {
                setItems([...items, value])
                setValue('');
            }
        }
    };

    const handleChange = (evt) => {
        setError('');
        setValue(evt.target.value);
    };

    const handleDelete = (item) => {
        setItems(items.filter(i => i !== item));
    };

    const handlePaste = (evt) => {
        evt.preventDefault();

        var paste = evt.clipboardData.getData("text");
        var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

        if (emails) {
            var toBeAdded = emails.filter(email => !isInList(email));


            setItems([...items, ...toBeAdded]);
        }
    };
    const isValid = (email) => {
        let error = '';

        if (isInList(email)) {

            error = `${email} ya ha sido agregado.`;
        }

        if (!isEmail(email)) {
            error = `${email} no es una dirección de correo electrónico válida.`;
        }

        if (error) {
            setError(error);
            return false;
        }

        return true;
    }

    const enviarCorreo = (esDesdeConfirmacion) => {
        if (!opcionesEnvio.terminado && !esDesdeConfirmacion && abrirConfirmar) {
            setOpcionesEnvio({ ...opcionesEnvio, dialogOpen: true });
            return;
        }

        setEnviando(true);
        correoCall().then(response => {
            if (response) {
                confirmar(true);
            }
            else {
                cerrar();
            }
        }).catch(err => {
            confirmar(false);
        });
    }

    const isInList = (email) => {
        return items.includes(email);
    }

    const isEmail = (email) => {
        return /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/.test(email);
    }

    const correoCall = async () => {
        let itemsUser=[...items];
        itemsUser.push(localStorage.getItem("usuario_nombre"));        
        if (tipo == 'cotizacion') {
            const username = encodeURIComponent(localStorage.getItem("usuario_nombre") || "");
            const url = `/cotizacion/reenviar-correo-cotizacion/${registroId}?username=${username}`;
            const result = await apiSource.postAsync<any>(url, itemsUser);                    
            return result;
        }
        else {
            const result = await apiSource.postAsync<any>("/solicitud-servicio/reenviar-correo-solicitud/" + registroId, itemsUser);
            return result;
        }
    }

    const terminarSolicitud = () => {
        enviarCorreo(true);
        setOpcionesEnvio({ ...opcionesEnvio, dialogOpen: false, terminado: true });
    }

    return (<>
        <Dialog
            maxWidth={"sm"} fullWidth={true}
            open={abierto}
            onClose={cerrar}
            aria-labelledby="max-width-dialog-title"
        >
            <DialogTitle id="max-width-dialog-title">

                {tipo == 'cotizacion' ? traducirMessage(296) : traducirMessage(297)}</DialogTitle>
            <DialogContent>
                {
                    tipo === 'cotizacion' &&
                    <DialogContentText>
                        {traducirMessage(16)}
                    </DialogContentText>
                }
                {
                    tipo !== 'cotizacion' &&
                    <DialogContentText>
                        {traducirMessage(17)}
                    </DialogContentText>
                }
                <p style={{ fontSize: "13px" }}>
                    {traducirMessage(89)}
                </p>
                <form className={classes.form} noValidate>
                    <FormControl className={classes.formControl}>

                        {items.map(item => (
                            <div className={classes.tagitem} key={item}>
                                {item}
                                <button
                                    type="button"
                                    className={classes.close}
                                    onClick={() => handleDelete(item)}
                                >
                                    &times;
                                </button>
                            </div>
                        ))}

                        <input
                            className={!error ? classes.input : classes.inputError}
                            style={{ minHeight: "30px" }}
                            value={value}

                            onKeyDown={handleKeyDown}
                            onChange={handleChange}
                            onPaste={handlePaste}
                        />
                        {error && <p className={classes.error}>{error}</p>}
                    </FormControl>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={cerrar} color="default" disabled={enviando}>
                    {/* Cerrar */
                    traducirButton(16)}
                </Button>
                <Button onClick={() => enviarCorreo(false)} color="primary" disabled={!items.length || enviando}>
                    {enviando &&
                        <ReactLoading type="spin" color="#19754e" height={15} width={15} />
                    }

                    {traducirLabel(120)}
                </Button>
            </DialogActions>
        </Dialog>

        {opcionesEnvio.dialogOpen &&
            // "Enviar Correo"
            // "Al enviar el correo ya no podrá hacer modificaciones ¿Desea continuar?"
            <ConfirmDialog titulo={traducirMessage(281)} abierto={opcionesEnvio.dialogOpen} confirmar={terminarSolicitud}
                contenido={traducirMessage(282)}
                cerrar={() => setOpcionesEnvio({ ...opcionesEnvio, dialogOpen: false })} />
        }
    </>)
};

export default EnviarCorreoDialog;
